let toastRef = null;

export const setAlertToastRef = (ref) => {
  toastRef = ref;
};

const showToast = ({ severity, summary, detail, life }) => {
  if (toastRef?.current?.show) {
    toastRef.current.show({ severity, summary, detail, life });
    return;
  }
  alert(detail ?? "");
};

export const appAlert = (message, options = {}) => {
  showToast({
    severity: options.severity ?? "info",
    summary: options.summary ?? "Info",
    detail: message ?? "",
    life: options.life,
  });
};

export const appAlertSuccess = (message, summary = "Success") =>
  appAlert(message, { severity: "success", summary });

export const appAlertInfo = (message, summary = "Info") =>
  appAlert(message, { severity: "info", summary });

export const appAlertWarn = (message, summary = "Warning") =>
  appAlert(message, { severity: "warn", summary });

export const appAlertError = (errorOrMessage, fallbackMessage) => {
  const errorMessage =
    typeof errorOrMessage === "string"
      ? errorOrMessage
      : errorOrMessage?.response?.data?.detail ??
        errorOrMessage?.message ??
        fallbackMessage;
  const errorStatus = errorOrMessage?.response?.status;
  const statusInfo = errorStatus ? ` (${errorStatus})` : "";
  appAlert(`${errorMessage ?? "Operation failed"}${statusInfo}`, {
    severity: "error",
    summary: "Error",
  });
  if (typeof errorOrMessage !== "string") {
    console.error(errorOrMessage);
  }
};